export enum WalletCategory {
  /** 系統收款 */
  SystemReceive = 0,
  /** 系統歸集 */
  SystemCollect = 1,
  /** 系統雜支 */
  SystemExpend = 2,
  /** 系統商收款 */
  ProviderReceive = 10,
  /** 系統商歸集 */
  ProviderCollect = 11,
  /** 系統商雜支 */
  ProviderExpend = 12,
  /** 營運商收款 */
  OperatorReceive = 20,
  /** 營運商歸集 */
  OperatorCollect = 21,
  /** 營運商雜支 */
  OperatorExpend = 22,
  /** 商戶收款 */
  TenantReceive = 30,
  /** 商戶歸集 */
  TenantCollect = 31,
  /** 商戶雜支 */
  TenantExpend = 32,
  /** 商戶代理收款 */
  TenantBrokerReceive = 40,
  /** 商戶代理歸集 */
  TenantBrokerCollect = 41,
  /** 商戶代理雜支 */
  TenantBrokerExpend = 42,
  /** 商戶會員收款 */
  TenantMemberReceive = 50,
  /** 商戶會員歸集 */
  TenantMemberCollect = 51,
  /** 商戶會員雜支 */
  TenantMemberExpend = 52,
  /** 未受管理 */
  External = 99,
}

export enum WalletStatus {
  disabled = 0,
  enabled = 1,
}

export enum BalanceCategory {
  /** 鏈網即時 */
  OfficialInstant = 0,
  /** 系統累計 */
  SystemAccumulated = 1,
}
